<template>
  <section id="why-us" class="why-us">
    <h1>{{ $t('DStudioWhyUsTitle') }}</h1>
    <div class="body" id="cards">
      <CardClassic
        :title="card.title"
        :subtitle="card.subtitle"
        :svg-component="card.svgComponent"
        v-for="(card, index) in cards"
        :style="{ 'transition-delay': `${index * 0.15}s`, 'animation-delay' : `${index * 0.15}s`}"
        :class="{ 'visible': cardsAreVisible }"
        :animate="true"
        :id="card.id"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import DsIconTariffs from '~/components/svg/design-studio/DsIconTariffs.vue';
import DsIconLighting from '~/components/svg/design-studio/DsIconLighting.vue';
import DsLightOn from '~/components/svg/design-studio/DsLightOn.vue';
import DsIconBad from '~/components/svg/design-studio/DsIconBad.vue';
import {onMounted, onUnmounted, ref} from "vue";

const cards = [
  {
    id: 2,
    title: 'DStudioWhyUsCard2Title',
    subtitle: 'DStudioWhyUsCard2Subtitle',
    svgComponent: DsIconLighting,
    isVisible: false,
  },
  {
    id: 1,
    title: 'DStudioWhyUsCard1Title',
    subtitle: 'DStudioWhyUsCard1Subtitle',
    svgComponent: DsIconTariffs,
    isVisible: false,
  },
  {
    id: 4,
    title: 'DStudioWhyUsCard4Title',
    subtitle: 'DStudioWhyUsCard4Subtitle',
    svgComponent: DsIconBad,
    isVisible: false,
  },
  {
    id: 3,
    title: 'DStudioWhyUsCard3Title',
    subtitle: 'DStudioWhyUsCard3Subtitle',
    svgComponent: DsLightOn,
    isVisible: false,
  },
];

const cardsAreVisible = ref(false);

const handleScroll = () => {
  const windowHeight = window.innerHeight;
  const el = document.getElementById(`cards`);
  if (el) {
    const rect = el.getBoundingClientRect();
    cardsAreVisible.value = rect.top < windowHeight;
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped lang="scss">
.why-us {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: $m-45;

  .body {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: $g-8;
    row-gap: $g-10;
    margin-top: $m-12;

    @media (max-width: 1271px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: $md) {
      row-gap: $g-5;
      grid-template-columns: 1fr;
      margin-top: $m-3;
    }
  }

  @media (min-width: 2000px) {
    min-height: unset;
  }
  @media (max-width: $lg) {
    width: 100%;
  }

  @media (max-width: $md) {
    gap: $g-5;
    margin-top: $m-40;
  }

  h1 {
    @include title-fw-700-fs-56-black-100;
    margin: 0px;
  }
}
</style>
import type DsLightOnVue from '../svg/design-studio/DsLightOn.vue';
